import React from 'react';

const eel = 'https://santaplaya-bucket.s3.amazonaws.com/eel.webp';
const bubbles = 'https://santaplaya-bucket.s3.amazonaws.com/bubbles_light.webp';
const shell = 'https://santaplaya-bucket.s3.amazonaws.com/Shell.webp';

const DessertSection: React.FC = () => {
  return (
    <section className="relative bg-white py-12 px-4 lg:px-24">
      {/* Accent Images */}
      {/* Top Left Bubbles */}
      <div className="pointer-events-none absolute top-0 left-[15%] w-[8vw] opacity-80">
        <img
          src={bubbles}
          alt="Bubbles Accent Top Left"
          className="w-full h-auto"
        />
      </div>
      {/* Top Right Bubbles */}
      <div className="pointer-events-none absolute top-0 right-[6.25%] w-[8vw] opacity-80">
        <img
          src={bubbles}
          alt="Bubbles Accent Top Right"
          className="w-full h-auto"
        />
      </div>
      {/* Bottom Left: Eel */}
      <div className="pointer-events-none absolute bottom-0 left-[12.5%] w-[17vw] opacity-90 -rotate-[20deg]">
        <img
          src={eel}
          alt="Eel Accent"
          className="w-full h-auto scale-x-[-1]"
        />
      </div>
      {/* Bottom Right: Shell */}
      <div className="pointer-events-none absolute bottom-0 right-[15%] w-[10vw] opacity-90">
        <img src={shell} alt="Shell Accent" className="w-full h-auto" />
      </div>

      {/* Main Content */}
      <div className="max-w-4xl mx-auto text-center relative z-10">
        <h2 className="font-charles text-maroon text-6xl md:text-7xl mb-6">
          POSTRE | DESSERT
        </h2>
        <div className="bg-white bg-opacity-20 inline-block p-6 rounded-md">
          <p className="font-charles text-sea text-5xl mb-2">
            Churros con Leche — $8
          </p>
        </div>
      </div>
      <div className="flex flex-col items-center justify-center mt-24">
        <a
          href="https://santaplaya-bucket.s3.us-west-2.amazonaws.com/Hand+Menu.pdf"
          target="_blank"
          rel="noopener noreferrer"
          download
          className="bg-sea text-white rounded-full py-2 px-6 md:py-3 md:px-8 font-prosto text-xs md:text-sm"
        >
          Download PDF Menu
        </a>
      </div>
    </section>
  );
};

export default DessertSection;
